<div class="row">
  <div class="col col-12 mx-auto">
    <div style="height: 300px;" id="hotel_map"></div>
  </div>
</div>
